import { Grid2Props } from '@mui/material';
import React from 'react';
import DonutChart from '../DemoComponents/DonutChart';
import { SummaryItemGrid } from './components';

export interface DonutGraphicProps extends Grid2Props {}

const DonutGraphic: React.FC<DonutGraphicProps> = ({ ...props }) => {
  return (
    <SummaryItemGrid
      id="project-performance-summary-item-donut"
      className="project-performance-summary-item-donut"
      gap={1}
      boxSizing={'border-box'}
      md={3}
      xs={4}
      overflow={'visible'}
      sx={{
        px: { xs: 0.5, md: 2 },
        py: { xs: 1, md: 4 },
        minHeight: { xs: '120px', md: '350px' },
        minWidth: { xs: '90px', md: '250px' },
      }}
      {...props}
    >
      <DonutChart sx={{ width: '15px' }} />
    </SummaryItemGrid>
  );
};

export default DonutGraphic;
